import { useMutation } from "@tanstack/vue-query"
import { v1 } from "@/axios"

export interface IBulkApproveModeratedContentItem {
  contentType?: "Photo" | "Video"
  contentId?: number
}

export interface IBulkApproveModeratedRequest {
  contents?: IBulkApproveModeratedContentItem[]
  notes?: string
}

interface IUseApproveModeratedMediaArgs {
  eventVaultId: number
  requestBody: IBulkApproveModeratedRequest
}

export async function approveModeratedMedia(requestBody: IBulkApproveModeratedRequest, eventVaultId: number) {
  await v1.patch(`/${eventVaultId}/moderate/bulk-approve`, requestBody)
}

export const APPROVE_MODERATED_MEDIA = "approveModeratedMedia"

export function useApproveModeratedMedia() {
  return useMutation({
    mutationKey: [APPROVE_MODERATED_MEDIA],
    mutationFn: ({ eventVaultId, requestBody }: IUseApproveModeratedMediaArgs) =>
      approveModeratedMedia(requestBody, eventVaultId),
  })
}
